import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import DataTable from '../../components/Table/DataTable';
import SearchBox from '../../components/SearchBox';
import { Button } from '@material-ui/core';
import { PlusIcon, TrashCanIcon } from '@stash-ui/regular-icons';
import { deleteLesson, getSpecialClasses } from '../../services/education';
import DeleteModal from '../EducationCourse/components/DeleteModal';
import { toast } from '@getpingback/realeza';

const EducationSpecialClasses = () => {
  const history = useHistory();

  const [courses, setCourses] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(0);
  const [searchField, setSearchField] = useState('');
  const [deleteModalOpen, setDeleteModalOpen] = useState({
    isOpen: false,
    courseId: null,
  });

  useEffect(() => {
    getSpecialClassesData(0, '');
  }, []);

  const headers = ['id', 'name', 'createdAt'];

  const getSpecialClassesData = async (page, searchTerm) => {
    try {
      const { data } = await getSpecialClasses(page, 20, searchTerm);
      setCourses(data.rows);
      setPage(Number(data.page));
      setTotalCount(data.count);
      setTotalPages(data.totalPages);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitSearch = searchBox => {
    setSearchField(searchBox.search);
    getSpecialClassesData(0, searchBox.search);
  };

  const handlePageChange = page => {
    setPage(page);
    getSpecialClassesData(page, searchField);
  };

  const formatedCourses = courses.map(course => ({
    uid: course.id,
    ...course,
  }));

  const handleDelete = async courseId => {
    try {
      await deleteLesson(courseId);
      getSpecialClassesData(0, '');
      setDeleteModalOpen({ isOpen: false, courseId: null });
      toast.success('Course deleted successfully');
    } catch (error) {
      console.error(error);
      toast.error(`Error deleting course: ${error?.response?.data?.error?.message}`);
    }
  };

  const customActions = [
    {
      icon: <TrashCanIcon color="#f96e6eb2" />,
      action: item => {
        setDeleteModalOpen({
          isOpen: true,
          courseId: item.id,
        });
      },
    },
  ];

  return (
    <div className="education">
      <div className="education__header">
        <h1>Education Special Classes ({totalCount})</h1>
        <div className="education__header__right">
          <Button variant="contained" startIcon={<PlusIcon />} onClick={() => history.push('/unique-lessons/course')}>
            Add Special Class
          </Button>
          <SearchBox selectItems={['name']} onSubmitSearch={handleSubmitSearch} />
        </div>
      </div>

      <DataTable
        useUid={true}
        head={headers}
        body={formatedCourses}
        customActions={customActions}
        bodyColumn={headers}
        linkPath={'unique-lessons/course'}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={handlePageChange}
      />

      <DeleteModal
        isOpen={deleteModalOpen.isOpen}
        onClose={() => setDeleteModalOpen({ isOpen: false, courseId: null })}
        onDelete={() => handleDelete(deleteModalOpen.courseId)}
        title="Delete Special Class"
        message="Are you sure you want to delete this special class?"
      />
    </div>
  );
};

export default EducationSpecialClasses;
